import { ChatMessage } from '@/lib/chat/ChatMessage'
import { FileUtils } from '@/lib/utils/FileUtils'
import { Http } from '@/lib/utils/Http'
import { SerializationHelper } from '@/lib/utils/SerializationHelper'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export class Chat extends VuexModule {
  public chatMessages: ChatMessage[] = []
  public uploadFiles: File[] = []
  public sendMessage: ChatMessage = new ChatMessage()

  uploadType: 'challenge' | 'upload' | '' = 'upload'
  pickedChallenge = 0
  driveUploaderSelected = false

  loadingMessages = true

  @Mutation
  public setDriveUploaderSelected (driveUploaderSelected: boolean) {
    this.driveUploaderSelected = driveUploaderSelected
  }

  @Mutation
  public setUploadType (uploadType: 'challenge' | 'upload' | '' = '') {
    this.uploadType = uploadType
  }

  @Mutation
  public updateChatMessages (chatMessages: ChatMessage[]) {
    this.chatMessages = chatMessages.filter(message => !message.deletedAt)

    this.loadingMessages = false
    if (chatMessages.length) {
      localStorage.setItem(`chat-messages-${chatMessages[0].rallyRoundId}`, JSON.stringify(this.chatMessages))
    }
  }

  @Mutation
  public setPickedChallenge (pickedChallenge: number) {
    this.pickedChallenge = pickedChallenge
  }

  @Mutation
  public updateWithOlderMessages (chatMessages: ChatMessage[]) {
    if (!chatMessages.length) {
      return
    }
    const filteredChatMessages = chatMessages
      .filter(chatMessage => {
        return !this.chatMessages.find(existingChatMessage => {
          return existingChatMessage.id === chatMessage.id
        })
      })
      .filter(chatMessage => !chatMessage.deletedAt)

    // remove deleted messages
    this.chatMessages = this.chatMessages.filter(chatMessage => !chatMessages.find(message => message.deletedAt && chatMessage.id === message.id))

    this.chatMessages.push(...filteredChatMessages)
    localStorage.setItem(`chat-messages-${chatMessages[0].rallyRoundId}`, JSON.stringify(this.chatMessages))
  }

  @Mutation
  public updateUploadFiles (files: File[]) {
    this.uploadFiles = files
  }

  @Mutation
  public updateSendMessage (sendMessage: ChatMessage) {
    this.sendMessage = sendMessage
  }

  @Mutation
  public removeUploadFile (file: File) {
    this.uploadFiles = this.uploadFiles.filter(uploadFile => uploadFile !== file)
    this.sendMessage.attachments = this.sendMessage.attachments.filter(async attachment => {
      return attachment.source !== await FileUtils.toBase64(file)
    })
  }

  @Action({ commit: 'updateChatMessages', rawError: true })
  public async loadAllMessages (rallyRoundId: number) {
    if (rallyRoundId) {
      const res = await Http.request(`/api/chat/posts/${rallyRoundId}`)
      return await res.json()
    }
  }
}
